import React, {useRef, useState} from 'react';
import {Controller} from 'react-hook-form';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import UploadIcon from '@mui/icons-material/Upload';
import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import {useUploadFileMutation} from "../../app/apis/upload.api";
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";

const CoverImage = ({name}) => {
  const {t} = useTranslation();
  const [open, setOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState({en: "", fr: ""});
  const uploadInputRef = useRef(null);
  const [uploadFile] = useUploadFileMutation();

  const onChangeUpload = (e) => {
    let selectedFile = e.target.files[0];
    const formData = new FormData();
    formData.append('file', selectedFile);

    uploadFile(formData)
        .then((resp) => {
          setDialogContent({
            ...dialogContent,
            uri: resp.data.temporaryLocation
          });
        });
  }

  const onSaveItem = (onChange) => {
    onChange({
      "lang": "en",
      "format": "file",
      "uri": dialogContent.uri,
      "desc": [
        {
          "lang": "en",
          "value": dialogContent.en
        },
        {
          "lang": "fr",
          "value": dialogContent.fr
        }
      ],
      "narrative": [
        {
          "lang": "en"
        },
        {
          "lang": "fr"
        }
      ]
    });
    setOpen(false);
  }

  const onEditItem = (value) => {
    if (value) {
      setDialogContent({
        en: value.desc[0]?.value,
        fr: value.desc[1]?.value,
        uri: value.uri
      });
    }

    setOpen(true);
  }

  const onDelete = (onChange) => {
    onChange(null);
  }

  return (
      <Controller
          name={name}
          render={({field}) => {


            return (
                <>
                  <Grid container>
                    <Grid item xs={6}>
                      Cover Image
                      {field?.value ?
                          <Box>
                            <Stack direction={'column'} spacing={2} mt={2}>
                              <TextField
                                  label={'Photo credits - En'}
                                  inputProps={{style: {fontSize: 14}}}
                                  size="small"
                                  sx={{width: 300}}
                                  value={field?.value.desc[0]?.value}
                              />
                              <TextField
                                  label={'Photo credits - Fr'}
                                  inputProps={{style: {fontSize: 14}}}
                                  size="small"
                                  sx={{width: 300}}
                                  value={field?.value.desc[1]?.value}
                              />
                            </Stack>
                          </Box> :
                          <Box>
                            {t('coverImageText')}
                          </Box>}
                      <Box>
                        <EditIcon sx={{fontSize: 14, cursor: "pointer"}} onClick={() => onEditItem(field.value)}/>
                        <DeleteForeverOutlinedIcon sx={{fontSize: 14, cursor: "pointer"}}
                                                   onClick={() => onDelete(field.onChange)}/>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      {field?.value?.uri && <img src={field?.value?.uri} style={{maxWidth: "100%", maxHeight: "100%"}}/>}
                    </Grid>
                  </Grid>
                  <Dialog
                      open={open}
                      onClose={() => setOpen(false)}
                  >
                    <Box p={2}>
                      <Stack direction={'column'} spacing={2}>
                        <TextField
                            label={'Photo credits - En'}
                            inputProps={{style: {fontSize: 12}}}
                            size="small"
                            value={dialogContent.en}
                            onChange={(e) => setDialogContent({...dialogContent, en: e.target.value})}
                        />
                        <TextField
                            label={'Photo credits - Fr'}
                            inputProps={{style: {fontSize: 12}}}
                            size="small"
                            value={dialogContent.fr}
                            onChange={(e) => setDialogContent({...dialogContent, fr: e.target.value})}
                        />
                      </Stack>

                      <Stack direction={'row'} spacing={1} mt={2}>
                        <Button variant="contained" onClick={() => uploadInputRef.current.click()}><UploadIcon
                            size="small"/> PNG</Button>
                        <Button variant="contained" onClick={() => onSaveItem(field.onChange)}>{t('save')}</Button>
                        <Button variant="contained" onClick={() => setOpen(false)}>{t('close')}</Button>
                      </Stack>
                      <input
                          type='file'
                          onChange={onChangeUpload}
                          style={{display: 'none'}}
                          accept='.png'
                          ref={uploadInputRef}
                      />
                    </Box>
                  </Dialog>
                </>
            )
          }}
      />
  )
};

export default CoverImage;
